import { PostHogEventEnum } from 'enums/posthog-event.enum';
import {
  PostHogProperties,
  PostHogPersonProperties,
  PostHogGlobalProperties
} from 'app/services/posthog/posthog-properties.types';

export abstract class AbPostHog {

  abstract init(): Promise<void>;

  abstract isReady(): boolean;

  abstract identify(distinctId: string | number, properties?: PostHogPersonProperties): void;

  abstract register(properties: PostHogGlobalProperties): void;

  abstract capture(event: PostHogEventEnum | string, properties?: PostHogProperties): void;

  abstract reset(): void;

  abstract optIn(userId: string | number): void;

  abstract optOut(userId: string | number): void;

  abstract isOptedOut(userId: string | number): boolean;
}
